// Extract Sheet ID from any Google Sheets URL
export function extractSheetId(url) {
  const match = url.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
  return match ? match[1] : null;
}

// Fetch sheet as CSV (sheet must be published to web)
export async function fetchSheetRows(sheetId) {
  // gviz/tq URL has better CORS support than /export
  const url = `https://docs.google.com/spreadsheets/d/${sheetId}/gviz/tq?tqx=out:csv&gid=0`;
  let res;
  try {
    res = await fetch(url);
  } catch (err) {
    throw new Error(`Impossible de contacter Google Sheets (CORS ou réseau) : ${err.message}`);
  }
  if (!res.ok) {
    throw new Error(`Sheet inaccessible (HTTP ${res.status}). Vérifie que le sheet est publié sur le web.`);
  }
  const text = await res.text();
  if (text.includes('<!DOCTYPE') || text.includes('<html')) {
    throw new Error('Google Sheets a retourné une page HTML au lieu du CSV. Vérifie que le sheet est bien publié sur le web (Fichier → Partager → Publier sur le web).');
  }
  return parseCSV(text);
}

// Column letter to index: A→0, B→1, C→2…
export function colIndex(letter) {
  if (!letter) return 0;
  return letter.toUpperCase().charCodeAt(0) - 65;
}

function parseCSV(text) {
  const lines = text.trim().split('\n');
  return lines.map(line => {
    const cols = [];
    let current = '';
    let inQuotes = false;
    for (const ch of line) {
      if (ch === '"') {
        inQuotes = !inQuotes;
      } else if (ch === ',' && !inQuotes) {
        cols.push(current.trim().replace(/^"|"$/g, ''));
        current = '';
      } else {
        current += ch;
      }
    }
    cols.push(current.trim().replace(/^"|"$/g, ''));
    return cols;
  });
}
